<form [formGroup]="form" (ngSubmit)="onSave()">
	@if (httpError.statusCode == 400) {
		<mat-error class="top-right-absolute-error-message">
			{{ 'mes.administration.batch.shared.errors.bad-request' | translate }}
		</mat-error>
	}
	@if (httpError.statusCode == 404) {
		<mat-error class="top-right-absolute-error-message">
			{{ 'mes.administration.batch.shared.errors.not-found' | translate }}
		</mat-error>
	}
	@if (httpError.statusCode == 500) {
		<mat-error class="top-right-absolute-error-message">
			{{ 'mes.administration.batch.shared.errors.internal-server-error' | translate }}
		</mat-error>
	}

	<h1 mat-dialog-title class="notification-title no-select">
		{{ 'mes.administration.batch.dialog.edit-batch' | translate }}
	</h1>

	<mat-dialog-content style="padding-top: 20px">
		<div class="optional-form-fields">
			@if (httpError.message.includes('Production data plan status is Processing.')) {
				<mat-error>
					{{ 'mes.administration.batch.shared.errors.plan-is-busy' | translate }}
				</mat-error>
			}
			@if (httpError.message.includes('already exists.')) {
				<mat-error>
					{{ 'mes.administration.batch.shared.errors.duplicate' | translate }}
				</mat-error>
			}
			@if (controls['alias'].invalid) {
				<mat-error>
					{{ 'mes.administration.batch.shared.errors.empty-or-invalid-characters-error' | translate }}
				</mat-error>
			}
			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">
					{{ 'mes.administration.batch.shared.alias' | translate }}
				</mat-label>
				<input maxlength="255" matInput formControlName="alias" [readonly]="fieldIsReadonly" [class.readonly]="fieldIsReadonly" />
			</mat-form-field>

			@if (controls['name'].invalid) {
				<mat-error>
					{{ 'mes.administration.batch.shared.errors.invalid-characters-error' | translate }}
				</mat-error>
			}

			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">
					{{ 'mes.administration.batch.shared.name' | translate }}
				</mat-label>
				<input maxlength="255" matInput formControlName="name" [readonly]="fieldIsReadonly" [class.readonly]="fieldIsReadonly" />
			</mat-form-field>

			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">
					{{ 'mes.administration.batch.shared.status' | translate }}
				</mat-label>
				<input maxlength="255" matInput [readonly]="true" [value]="'mes.administration.batch.shared.statuses.' + (batch.status | lowercase) | translate" />
			</mat-form-field>

			<div class="button-toggle-group">
				@if (!hideButton || isMesManager) {
					<button [disabled]="disableDraftButton && !isMesManager" mat-button type="button" [class.selected]="isDraftSelected" (click)="onDraftChange()">
						{{ 'mes.administration.batch.shared.buttons.move-to-draft' | translate }}
					</button>
				}
				@if (!hideButton || (isMesManager && !isArchived)) {
					<button [disabled]="disableNextButton" mat-button type="button" [class.selected]="isNextSelected" (click)="onNextChange()">
						{{ 'mes.administration.batch.shared.buttons.' + (batch.status | lowercase) | translate }}
					</button>
				}
			</div>
		</div>
	</mat-dialog-content>

	<div>
		<div mat-dialog-actions align="end">
			<button mat-flat-button color="primary" type="submit" [disabled]="loading || form.invalid || !hasChanges">
				{{ 'mes.administration.batch.shared.savebtn' | translate }}
			</button>
			<button mat-stroked-button type="button" (click)="onCancel()" (window:keyup.escape)="onCancel()" class="button-border-color">
				{{ 'mes.administration.batch.shared.cancelbtn' | translate }}
			</button>
		</div>
	</div>
</form>
